let unit_pbgid = require("../config/unit_pbgid.json")

function getKeyFromPbgId(pbgId) {
    for (const [key, units] of Object.entries(unit_pbgid)) {
        if (units.some(unit => unit.pbgid === pbgId)) {
            return key; // return the first matching key
        }
    }
    return null; // not found
}

export function filterOutEconomy(squads) {
    const blocked = [
        "trade",
        "villager",
        "imperial-official",
        "fishing-",
        "jeanne-darc-peasant",
        "yatai",
        "worker"
    ];

    if (!squads) return [];
    return squads.filter(squad => {
        const key = getKeyFromPbgId(squad);
        return key && !blocked.some(term => key.includes(term));
    });
}

export function getCombinedCount(data, ids) {
  return data.reduce((total, item) => {
    if (ids.includes(item.pbg_id)) {
      total += item.count;
    }
    return total;
  }, 0);
}

export function getFrequencyCount(data, ids) {
  return data.reduce((count, item) => {
    if (ids.includes(item.pbg_id) && item.building_progress === 1) {
      count++;
    }
    return count;
  }, 0);
}